import 'chart.js/auto';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import styles from './network.module.scss';

const NetworkErrTraffic = ({ header, networkErrTraffic }) => {
  // networkTraffic 문자열을 객체 배열로 파싱
  const rows = (networkErrTraffic+"").trim().split('\n').slice(1);
  // const labels = ['rxpck/s', 'txpck/s', 'rxkB/s'];
  const labels = header;

  const dataSets = rows.map(row => {
    // const [IFACE, rxpck, txpck, rxkB] = row.trim().split(/\s+/);
    const header1 = row.trim().split(/\s+/);
    return {
      label: header1[0],
      data: header1.slice(1).map(item => parseFloat(item)),
      backgroundColor: `hsla(${Math.random() * 360}, 80%, 65%, 0.8)`,
      borderColor: `hsla(${Math.random() * 360}, 80%, 45%, 1)`,
      borderWidth: 0,
    };
  });

  // console.log("dataSets["+dataSets+"]");
  const hasData = dataSets.some(dataset => dataset.data.some(value => value !== '' && value !== 'N/A'));
  // console.log("NetworkErrTraffic hasData["+hasData+"]");

  const data = {
    labels,
    datasets: hasData ? dataSets : [],
    // datasets: dataSets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 20,
            weight: 'bold'
          },
          padding: 20
        },
      },
      tooltip: {
        titleFont: {
          size: 16
        },
        bodyFont: {
          size: 14
        }
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 16
          }
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 16
          }
        }
      }
    },
    barThickness: 20,
  };

  return (
    <div className={styles.network_err_traffic_container}>
      <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>Network Error Traffic</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default NetworkErrTraffic;
